export default __webpack_public_path__ + "static/media/futura-preview-redeem.57ec37c8.png";